var exports = {
  "k": "x93eb46d8--d5abe9--container",
  "K": "x93eb46d8--d5abe9--icon",
};

module.exports = exports;
